export default {
  getCashDetail: '/gateway/capp/WithDrawTradeFacade/queryCourierWithdrawRecordDetail'
}
